import React from "react";
import { useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { ExpenseList } from "../../components/expense";
import { CREATE_EXPENSE } from "../../constants";
import { useHasPermission } from "../../utils";

export const Expenses = () => {
  const hasAddExpense = useHasPermission(CREATE_EXPENSE);

  const navigate = useNavigate();

  const handleAddClick = () => {
    navigate("/expense/add");
  };

  const buttons = [
    hasAddExpense && {
      buttonText: "Add Expense",
      buttonIcon: Add,
      onClick: handleAddClick,
    },
  ];

  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title="Expenses" buttons={buttons} />
      </Box>
      <Box sx={{ mt: -9, position: "relative", zIndex: 2 }}>
        <ExpenseList />
      </Box>
    </PageLayout>
  );
};
